import React, {Component} from 'react'; // eslint-disable-line no-unused-vars
import dom from '../../utils/dom';
import edap from '../../utils/edap';
import haWrapper from '../../utils/ha-wrapper';

export default class Page extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {pagename} = this.props;
        edap.pageview(pagename);
        dom.scrollToTop();
    }

    componentWillUnmount() {
        // Since we log PAR on multiple pages, we need to mark
        // this to reset our zero-point mark after client-side
        // routing takes over.
        haWrapper.userTiming.mark('page.unload');
    }

    render() {
        const {children} = this.props;
        // Support <PageView /> and <PageView>...</PageView>
        return children || null;
    }
}


// WEBPACK FOOTER //
// ./src/universal/components/PageView/PageView.js